const PRODUCT_ITEM_GET_LIST_REQUEST = 'PRODUCT_ITEM_GET_LIST_REQUEST';
const PRODUCT_ITEM_GET_LIST_SUCCESS = 'PRODUCT_ITEM_GET_LIST_SUCCESS';
const PRODUCT_ITEM_GET_LIST_FAILURE = 'PRODUCT_ITEM_GET_LIST_FAILURE';

export default {
  PRODUCT_ITEM_GET_LIST_REQUEST,
  PRODUCT_ITEM_GET_LIST_FAILURE,
  PRODUCT_ITEM_GET_LIST_SUCCESS,
};
